const codeModule = {
  "101": "未接收到資料",
  "102": "簽名驗證失敗，請重新登錄",
  "103": "驗證碼發送失敗",
  "104": "缺少手機號",
  "105": "缺少密碼",
  "106": "該號碼已註冊，請返回登錄",
  "111": "註冊失敗",
  "107": "驗證碼錯誤",
  "108": "帳號密碼不匹配",
  "109": "帳號不存在",
  "110": "密碼修改失敗",
  "112": "退出失敗",
  "113": "修改使用者資訊失敗",
  "114": "缺少參數",
  "115": "保存失敗",
  "121": "卡信息不完整",
  "122": "沒有ID",
  "201": "店鋪不存在",
  "202": "餐桌不存在",
  "203": "不可連續留言",
  "204": "用戶沒有在任何門店消費過",
  "205": "美食廣場不存在",
  "206": "店鋪未營業",
  "301": "未添加商品類型",
  "302": "商品不存在",
  "303": "已售罄",
  "304": "請輸入套餐適用人數",
  "305": "菜品不存在",
  "306": "套餐不存在",
  "307": "不支持店內",
  "308": "不支持配送自提",
  "309": "部分商品库存不足",
  "400": "驗證碼不正確",
  "401": "配送地址不存在",
  "403": "超出配送範圍",
  "404": "購物車中沒有商品",
  "405": "請輸入用餐人數",
  "407": "請選擇餐桌",
  "408": "此餐桌已被鎖定",
  "409": "未到起送價格",
  "410": "總金額必須大於1円",
  "411": "添加訂單失敗，請重試",
  "412": "訂單不存在",
  "413": "該訂單已支付",
  "415": "訂單已評論過",
  "416": "請選擇評級",
  "417": "評論失敗，請重試",
  "418": "已列印領收書",
  "419": "列印失敗",
  "420": "請填寫公司名稱",
  "421": "訂單未評論",
  "422": "支付訂單不可取消",
  "423": "取消失敗",
  "424": "您沒有對此訂單操作許可權",
  "425": "確認收貨失敗",
  "426": "該訂單不能加菜",
  "427": "信用卡資訊錯誤，請檢查",
  "428": "支付失敗，請檢查後重試",
  "429": "不在自提時間內",
  "430": "不在配送時間內",
  "431": "不支持的支付方式",
  "433": "没有选择时间",
  "501": "優惠券不存在",
  "502": "已領完",
  "503": "超過單人領取上限",
  "504": "領取失敗，請重試",
  "505": "優惠券已使用或者已過期",
  "506": "不滿足使用條件",
  "1000": "多規格商品請到購物車中刪除!",
  "1001": "確認收貨成功"
};

export default codeModule;
